import axios from 'axios';
import { authAxios } from './apiClient';

// Public reads use plain `axios` (anonymous visitors must never be prompted
// to log in). Admin reads/writes use `authAxios`, which attaches the bearer
// token and routes a 401 into the shared re-login + retry flow.
const API_URL = process.env.REACT_APP_API_URL || '';

// ===== Solutions =====

// Public
export const getSolutions = async () => {
    const res = await axios.get(`${API_URL}/api/solutions`);
    return res.data;
};

/** 정본 경로로 조회. `/solutions/{대표코드}/{slug}` 가 쓴다. */
export const getSolutionByPath = async (category, slug) => {
    const res = await axios.get(`${API_URL}/api/solutions/by-path/${category}/${slug}`);
    return res.data;
};

export const getSolution = async (id) => {
    const res = await axios.get(`${API_URL}/api/solutions/${id}`);
    return res.data;
};

// Admin
export const getAdminSolutions = async () => {
    const res = await authAxios.get(`${API_URL}/api/admin/solutions`);
    return res.data;
};

export const getAdminSolution = async (id) => {
    const res = await authAxios.get(`${API_URL}/api/admin/solutions/${id}`);
    return res.data;
};

export const createSolution = async (data) => {
    const res = await authAxios.post(`${API_URL}/api/admin/solutions`, data);
    return res.data;
};

export const updateSolution = async (id, data) => {
    const res = await authAxios.put(`${API_URL}/api/admin/solutions/${id}`, data);
    return res.data;
};

export const deleteSolution = async (id) => {
    const res = await authAxios.delete(`${API_URL}/api/admin/solutions/${id}`);
    return res.data;
};

export const reorderSolutions = async (ids) => {
    const res = await authAxios.post(`${API_URL}/api/admin/solutions/reorder`, { ids });
    return res.data;
};

// ===== Popups =====

// Public
export const getActivePopups = async (page) => {
    const res = await axios.get(`${API_URL}/api/popups/active`, {
        params: { page }
    });
    return res.data;
};

// Admin
export const getAdminPopups = async () => {
    const res = await authAxios.get(`${API_URL}/api/admin/popups`);
    return res.data;
};

export const getAdminPopup = async (id) => {
    const res = await authAxios.get(`${API_URL}/api/admin/popups/${id}`);
    return res.data;
};

export const createPopup = async (data) => {
    const res = await authAxios.post(`${API_URL}/api/admin/popups`, data);
    return res.data;
};

export const updatePopup = async (id, data) => {
    const res = await authAxios.put(`${API_URL}/api/admin/popups/${id}`, data);
    return res.data;
};

export const deletePopup = async (id) => {
    const res = await authAxios.delete(`${API_URL}/api/admin/popups/${id}`);
    return res.data;
};

export const reorderPopups = async (ids) => {
    const res = await authAxios.post(`${API_URL}/api/admin/popups/reorder`, { ids });
    return res.data;
};
